import React from "react";
import Modal from "../../../components/general/Modal";
import {
  Title,
  SubTitle,
  FlowName,
  Footer,
  Container,
  DivIcon,
} from "./styles";
import Button from "../../../components/general/Button";
import Close from "../../../assets/icons/Close";
import { usePromiseTracker } from "react-promise-tracker";

//? Confirm Copy modal:
//isOpen -> Controlador se o modal está aberto ou não
//onClose -> Função executada ao cancelar/fechar/clicar fora do modal
//onConfirm -> Função executada ao confirmar no modal
//selector -> Local onde o modal sera renderizado(root -> Toda a tela)
//className -> nodrag = modal não pode ser movido
//flowName -> Nome renderizado na tela

const ConfirmCopyModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  flowName,
}) => {
  const { promiseInProgress } = usePromiseTracker({ area: "copyModal" });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Confirmar cópia de modelo</Title>
        <SubTitle>
          Deseja criar uma <strong>CÓPIA</strong> deste projeto?
        </SubTitle>
        <FlowName> {!promiseInProgress ? flowName : "Copiando.."} </FlowName>
        <Footer>
          {!promiseInProgress ? (
            <>
              <Button
                outline
                content="Cancelar"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={onClose}
              />
              <Button
                content="Confirmar cópia"
                width={"11.3125rem"}
                height={"2.625rem"}
                onClick={() => {
                  onConfirm();
                }}
              />
            </>
          ) : null}
        </Footer>
        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default ConfirmCopyModal;
